import { Localisation } from '../libs/Localisation';
import App from '../main';

export default class UI extends Phaser.Scene {

    private gameScene;

    private highScoreText: Phaser.GameObjects.Text;
    private scoreText: Phaser.GameObjects.Text;
    private rubixCubesUI1: Phaser.GameObjects.Image;
    private rubixCubesUI2: Phaser.GameObjects.Image;
    private rubixCubesUI3: Phaser.GameObjects.Image;

    private retryContainer: Phaser.GameObjects.Container;
    private scoreBoard: Phaser.GameObjects.Image;
    private finalScoreText: Phaser.GameObjects.Text;
    private finalHighScoreText: Phaser.GameObjects.Text;
    private retryButton: Phaser.GameObjects.Image;
    // private fbInstantShareButton: Phaser.GameObjects.Image;
    private exitButton: Phaser.GameObjects.Image;
    private retryHeader: Phaser.GameObjects.Text;
    // private homeButton: Phaser.GameObjects.Image;

    private restartButton: Phaser.GameObjects.Image;
    private menuButton: Phaser.GameObjects.Image;
    private resumeButton: Phaser.GameObjects.Image;
    private pauseMenu: Phaser.GameObjects.Image;
    private pauseHeader: Phaser.GameObjects.Text;
    private pauseMenuContainer: Phaser.GameObjects.Container;

    private pauseButton: Phaser.GameObjects.Image;
    private pauseImage: Phaser.GameObjects.Image;
    private pauseContainer: Phaser.GameObjects.Container;
    private rubixContainer: Phaser.GameObjects.Container;
    private lifeContainer: Phaser.GameObjects.Container;
    private starsContainer: Phaser.GameObjects.Container;
    private soundButton: Phaser.GameObjects.Image;
    private soundImage: Phaser.GameObjects.Image;
    private soundContainer: Phaser.GameObjects.Container;
    private closeButton: Phaser.GameObjects.Image;
    // private pauseCloseButton:Phaser.GameObjects.Image;
    private closeImage: Phaser.GameObjects.Image;
    private closeContainer: Phaser.GameObjects.Container;

    private paused = false;
    public get Paused(): boolean {
        return this.paused;
    }

    public set Paused(value: boolean) {
        this.paused = value;
    }

    private adMenu: Phaser.GameObjects.Image;
    private adWaitingMenu: Phaser.GameObjects.Image;

    private countDownTween: Phaser.Tweens.Tween;
    private adCountDown: Phaser.GameObjects.Text;
    private yesButton: Phaser.GameObjects.Text;
    private noButton: Phaser.GameObjects.Text;
    private adContainer: Phaser.GameObjects.Container;
    private adWaitingContainer: Phaser.GameObjects.Container;

    private powerUpIcon: Phaser.GameObjects.Image;
    private powerUpTimer: Phaser.GameObjects.Sprite;
    private powerUpText: any;
    private powerUpTextTween: Phaser.Tweens.Tween;

    private width: number;
    private height: number;
    private width_half: number;
    private height_half: number;
    private ratio: number;

    private adWatchedIndex: number = 0;

    private inGame: boolean = false;

    private lifeUI1: Phaser.GameObjects.Image;
    private lifeUI2: Phaser.GameObjects.Image;
    private lifeUI3: Phaser.GameObjects.Image;

    private starsUIIcon: Phaser.GameObjects.Image;
    private starsUILabel: any;

    private insetPadding: any;

    constructor() {
        super('UI');
    }

    create() {
        this.inGame = true;

        this.insetPadding = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }

        this.resize(this.scale.gameSize);
        this.width = this.cameras.main.displayWidth;
        this.height = this.cameras.main.displayHeight;
        this.width_half = this.width / 2;
        this.height_half = this.height / 2;
        this.ratio = this.width / App.MAX_WIDTH;

        this.gameScene = this.scene.get('NormalMode');
        this.setOverlay();
        this.setPowerUpUI();
        this.setPauseMenu();
        this.setRetryMenu();
        this.setAdMenu();
        this.setupAdWaitingContainer();
        
        this.gameScene.emitter.on('gameOverScreen', this.setGameOverScreen, this);

        this.registry.events.on('changedata', this.updateData, this);
        this.retryButton.on('pointerup', this.restartGame, this);
        this.exitButton.on('pointerup', this.exitGame, this);
        this.pauseButton.on('pointerup', this.pauseGame, this);
        this.resumeButton.on('pointerup', this.resumeGame, this);
        this.soundButton.on('pointerdown', this.setSound, this);
        this.closeButton.on('pointerdown', this.closeGame, this);
        this.yesButton.on('pointerdown', () => this.showAd(0), this);
        this.noButton.on('pointerdown', () => this.onRewardsAd(false), this);

        // this.fbInstantShareButton.on('pointerup', this.SDKShare, this);

        App.SDK.canShowInterstitialAd = true;
        App.SDK.isTournamentAfterGame = false;

        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === 'hidden' && this.inGame) {
                this.pauseGame();
            }
        });
    }

    changeAudioState(state: boolean): void {
        this.game.sound.mute = state
    }

    closeGame() { // Called by Exit button in Pause panel.
        if (App.SDK.canShowInterstitialAd == true) {
            this.pauseContainer.setVisible(false);
            this.adWaitingContainer.setVisible(true);
            this.sound.mute = true;
            App.SDK.watchInterstitialAd((value) => {
                this.adWaitingContainer.setVisible(false);
                if (!App.MUTE) {
                    this.sound.mute = false;
                }
                this.goToMainMenu();
                App.SDK.loadInterstitialAd();
            });
        }
        else {
            this.goToMainMenu();
        }
        App.SDK.onGameExit(this.registry.get('score'), this.registry.get('highScore'))
    }

    

    setGameOverScreen() {
        this.inGame = false;
        App.lives -= 1;
        switch (App.lives) {
            case 0:
                this.lifeUI1.setTexture('Dead');
                break;
            case 1:
                this.lifeUI2.setTexture('Dead');
                break;
            case 2:
                this.lifeUI3.setTexture('Dead');
                break;
        }
        if (App.lives > 0) {
            setTimeout(() => {
                this.inGame = true;
                this.gameScene.revive();
            }, 500);
        } else {
            App.lives = 0;
            this.pauseContainer.setVisible(false);
            this.rubixContainer.setVisible(false);
            this.lifeContainer.setVisible(false);
            this.starsContainer.setVisible(false);
            // this.showRetryMenu();
            App.SDK.checkRewardedVideoAds(this.checkRewardedVideoAdsCallback.bind(this));
        }
    }

    checkRewardedVideoAdsCallback(adAvailable: boolean) {
        if (adAvailable) {
            this.showAdMenu();
        }
        else {
            this.showRetryMenu();
        }
    }

    showAdMenu() {
        this.gameScene.cameras.main.setAlpha(0.5);
        this.retryContainer.setVisible(false);
        this.adContainer.setVisible(true);
        this.countDownTween.play();
    }

    showAd(index: number) {
        this.adWatchedIndex = index;
        this.adContainer.setVisible(false);
        this.retryContainer.setVisible(false);
        this.game.sound.mute = true;
        this.countDownTween.stop();
        this.adWaitingContainer.setVisible(true);
        App.SDK.watchRewardAd('life', this.onRewardsAd.bind(this));
        // this.onRewardsAd(true);
    }

    onRewardsAd(adWatched: boolean) {
        this.adWaitingContainer.setVisible(false);
        App.MUTE ? this.game.sound.mute = true : this.game.sound.mute = false;
        if (adWatched) {
            App.lives = App.maxLives;
            this.lifeUI1.setTexture('Life');
            this.lifeUI2.setTexture('Life');
            this.lifeUI3.setTexture('Life');
            this.gameScene.cameras.main.setAlpha(1);
            setTimeout(() => {
                this.gameScene.revive();
            }, 550);
            this.pauseContainer.setVisible(true);
            this.rubixContainer.setVisible(true);
            this.lifeContainer.setVisible(true);
            this.starsContainer.setVisible(true);
            this.inGame = true;
            App.SDK.totalAdsWatched = 1;
            App.SDK.canShowInterstitialAd = false;
        }
        else {
            this.countDownTween.stop();
            this.adContainer.setVisible(false);
            this.retryContainer.setVisible(false);
            this.showRetryMenu();
        }
    }

    showRetryMenu() {
        this.lifeUI1.setTexture('Life');
        this.lifeUI2.setTexture('Life');
        this.lifeUI3.setTexture('Life');
        App.lives = App.maxLives;

        this.gameScene.cameras.main.setAlpha(0.5);
        this.finalScoreText.setText(this.registry.get('score'));
        this.finalHighScoreText.setText(Localisation.TEXTS.GAME_BEST_TEXT[App.langIndex] + ': ' + this.registry.get('highScore'));
        this.retryContainer.setVisible(true);
        this.scoreText.setVisible(false);
        this.highScoreText.setVisible(false);

        // if (this.registry.get('score') > localStorage.getItem('hammerplay_doodledrop_highscore')) {
        //     localStorage.setItem('hammerplay_doodledrop_highscore', this.registry.get('score'));
        // }

        App.SDK.sendScore(this.registry.get('score'));
        if (this.registry.get('score') >= App.SDK.HighestScore) {
            App.SDK.HighestScore = this.registry.get('score');
            App.SDK.setDataHighScore(App.SDK.HighestScore);
        }

        // this.changeAudioState(true);
        App.SDK.onResultScreen(this.registry.get('score'), this.registry.get('highScore'));
    }

    pauseGame() {
        if (!this.inGame) return;
        if (!this.gameScene.gameOver) {
            // if (this.paused) {
            //     this.resumeGame();
            // }
            // else {
                App.SDK.onGamePause();
                this.pauseContainer.setVisible(false);
                this.rubixContainer.setVisible(false);
                this.lifeContainer.setVisible(false);
                this.starsContainer.setVisible(false);
                this.paused = true;
                this.pauseMenuContainer.setVisible(true);
                if (this.scene.isActive('NormalMode')) {
                    this.scene.pause('NormalMode');
                }
                else if (this.scene.isActive('RushMode')) {
                    this.scene.pause('RushMode');
                }
                if (this.scene.isActive('Tutorial')) {
                    this.scene.sleep('Tutorial');
                }
            // }
        }

    }

    resumeGame() {
        if (!this.inGame) return;
        if (!this.gameScene.gameOver) {
            App.SDK.onGameResume();
            this.paused = false;
            this.pauseContainer.setVisible(true);
            this.rubixContainer.setVisible(true);
            this.lifeContainer.setVisible(true);
            this.starsContainer.setVisible(true);
            if (this.scene.isPaused('NormalMode')) {
                this.scene.resume('NormalMode');
            }
            else if (this.scene.isPaused('RushMode')) {
                this.scene.resume('RushMode');
            }
            if (this.scene.isSleeping('Tutorial')) {
                this.scene.wake('Tutorial');
            }
            this.pauseMenuContainer.setVisible(false);
        }
    }

    setSound() {
        if (App.MUTE) {
            App.MUTE = this.sound.mute = false;
            this.soundImage.setTexture('UI_New', 'UI_New_6');
        } else {
            App.MUTE = this.sound.mute = true;
            this.soundImage.setTexture('UI_New', 'UI_New_5');
        }
    }

    setOverlay() {
        var highScore: number = this.gameScene.highScore || 0;
        this.highScoreText = this.add.text(this.width_half, (0.75 * 50) + this.insetPadding.top, Localisation.TEXTS.GAME_BEST_TEXT[App.langIndex] + ': ' + highScore.toString(), { fontFamily: 'FredokaOne', fontSize: '64px', fontStyle: 'bold', fill: '#712E3A' });
        this.highScoreText.setOrigin(0.5).setScrollFactor(1, 0);

        this.scoreText = this.add.text(this.width_half, 0.75 * 220 + this.insetPadding.top, '0', { fontFamily: 'FredokaOne', fontSize: '160px', fontStyle: 'bold', fill: '#712E3A' });
        this.scoreText.setOrigin(0.5).setScrollFactor(1, 0);
        this.rubixCubesUI1 = this.add.image(0.75 * -200, 0 + this.insetPadding.top, 'Ui_4', 'Ui_4_3').setScale(0.75 * 0.4);
        this.rubixCubesUI2 = this.add.image(0.75 * -100, 0 + this.insetPadding.top, 'Ui_4', 'Ui_4_3').setScale(0.75 * 0.4);
        this.rubixCubesUI3 = this.add.image(0, 0 + this.insetPadding.top, 'Ui_4', 'Ui_4_3').setScale(0.75 * 0.4);
        this.rubixContainer = this.add.container(this.width * 0.960, 0.75 * 64, [this.rubixCubesUI1, this.rubixCubesUI2, this.rubixCubesUI3]).setScrollFactor(1, 0);

        this.lifeUI1 = this.add.image(0, 0 + this.insetPadding.top, 'Life');
        this.lifeUI2 = this.add.image(0.75 * 110, 0 + this.insetPadding.top, 'Life');
        this.lifeUI3 = this.add.image(0.75 * 220, 0 + this.insetPadding.top, 'Life');
        this.lifeContainer = this.add.container(0.75 * 64, 0.75 * 64, [this.lifeUI1, this.lifeUI2, this.lifeUI3]).setScrollFactor(1, 0);

        this.starsUIIcon = this.add.sprite(0, -100, 'PowerUps', 'PowerUps_2').setScale(0.4);
        this.starsUILabel = this.add.text(70, -135, App.stars.toString(), { fontFamily: 'FredokaOne', fontSize: '64px', fontStyle: 'bold', fill: '#712E3A' });
        this.starsContainer = this.add.container(0.75 * 64, 1.25 * 200, [this.starsUIIcon, this.starsUILabel]).setScrollFactor(1, 0);

        this.pauseButton = this.add.image(0, 0, 'UI_New', 'UI_New_8').setInteractive().setOrigin(0.5);
        this.pauseImage = this.add.image(0, -10, 'UI_New', 'UI_New_7').setOrigin(0.5).setScale(1.33);
        this.pauseContainer = this.add.container(this.width * 0.950, (0.75 * 100) + this.insetPadding.top + 90, [this.pauseButton, this.pauseImage]).setScale(0.75 * 0.5).setScrollFactor(1, 0);

        if (App.MUTE == false) {
            this.changeAudioState(false);
        }
    }

    setPowerUpUI() {
        this.powerUpIcon = this.add.image(this.width - 0.75 * 150, 0.75 * 350, 'PowerUps', 'PowerUps_0').setOrigin(0.5).setScale(0.75 * 0.4).setVisible(false);
        this.powerUpTimer = this.add.sprite(this.width - 0.75 * 150, 0.75 * 350, 'PowerUps', 'PowerUps_9').setOrigin(0.5).setScale(0.75 * 0.55).setVisible(false);
        this.powerUpText = this.add.text(this.width_half, this.height_half, 'MEGA', { fontFamily: 'FredokaOne', fontSize: '120px', fontStyle: 'bold', fill: '#fff' });
        this.powerUpText.setShadow(0, 0.75 * -15, '#6F2F3B').setStroke(0.75 * 5, 0.75 * 5, '#6F2F3B').setOrigin(0.5).setScrollFactor(1, 0).setVisible(false);
        this.powerUpTextTween = this.tweens.add({
            targets: this.powerUpText,
            paused: true,
            x: { from: this.width + this.powerUpText.displayWidth / 2, to: this.width_half },
            duration: this.ratio * 250,
            hold: this.ratio * 500,
            onComplete: () => this.tweens.add({
                targets: this.powerUpText,
                x: -this.powerUpText.displayWidth / 2,
                duration: this.ratio * 250
            }),
            onCompleteScope: this
        });
    }

    setRetryMenu() {
        this.scoreBoard = this.add.image(0, 0, 'ScoreBoard', 'ScoreBoard_0').setOrigin(0.5).setScale(0.75 * 1).setRotation(3.14);
        this.retryHeader = this.add.text(0, -266, Localisation.TEXTS.GAME_OVER_TEXT[App.langIndex], { fontFamily: 'FredokaOne', fontSize: '120px', fontStyle: 'bold', fill: '#712E3A', strokeThickness: 16 }).setOrigin(0.5);

        var finalScore = this.add.text(0, -(this.scoreBoard.displayHeight * 0.325), Localisation.TEXTS.GAME_SCORE_TEXT[App.langIndex], {
            fontSize: '105px', fontStyle: 'bold', fill: '#FFF', align: 'center'
        }).setShadow(0.75 * 15, 0.75 * 15, '#EC8451').setOrigin(0.5);
        this.finalScoreText = this.add.text(0, 0.75 * 5, '0', { fontSize: '225px', fontStyle: 'bold', fill: '#FFF' })
        this.finalScoreText.setShadow(0.75 * 25, 0.75 * 25, '#EC8451').setOrigin(0.5);
        this.finalHighScoreText = this.add.text(0, (this.scoreBoard.displayHeight * 0.29), Localisation.TEXTS.GAME_BEST_TEXT[App.langIndex] + ': 0', {
            fontSize: '75px', fontStyle: 'bold', fill: '#FFF'
        }).setShadow(0.75 * 15, 0.75 * 15, '#EC8451').setOrigin(0.5, 0.5);
        var gameOverContainer = this.add.container(this.width_half, this.height * 0.4, [this.scoreBoard, finalScore, this.finalScoreText, this.finalHighScoreText, this.retryHeader]);

        this.retryButton = this.add.image(0, 0, 'UI_New', 'UI_New_3').setInteractive().setOrigin(0.5);
        var retryImage = this.add.image(0, 0, 'UI_New', 'UI_New_1').setOrigin(0.5);
        var retryContainer = this.add.container(this.width_half - 250, this.height * 0.6, [this.retryButton, retryImage]).setScale(0.75 * 0.75);

        this.exitButton = this.add.image(0, 0, 'UI_New', 'UI_New_3').setInteractive().setOrigin(0.5);
        var exitImage = this.add.image(0, 0, 'closeButton').setOrigin(0.5);
        var exitContainer = this.add.container(this.width_half + 250, this.height * 0.6, [this.exitButton, exitImage]).setScale(0.75 * 0.75);

        // this.fbInstantShareButton = this.add.image(this.width_half, this.height * 0.725, 'fbinstant_shareButton').setInteractive().setOrigin(0.5).setScale(2);

        this.retryContainer = this.add.container(0, 0, [gameOverContainer, retryContainer, exitContainer]);
        this.retryContainer.setVisible(false).setScrollFactor(1, 0);
    }

    setPauseMenu() {
        this.pauseMenu = this.add.image(this.width_half, this.height * 0.42, 'ScoreBoard', 'ScoreBoard_0').setOrigin(0.5, 0.5).setScale(0.75 * 1).setRotation(3.14);
        this.pauseHeader = this.add.text(this.width_half, this.height * 0.30, Localisation.TEXTS.GAME_PAUSE_TEXT[App.langIndex], { fontFamily: 'FredokaOne', fontSize: '160px', fontStyle: 'bold', fill: '#712E3A', strokeThickness: 16 }).setOrigin(0.5);

        this.resumeButton = this.add.image(0, 0, 'UI_New', 'UI_New_3').setInteractive().setOrigin(0.5);
        var resumeImage = this.add.image(0, 0, 'UI_New', 'UI_New_2').setOrigin(0.5);
        var resumeContainer = this.add.container(this.width_half - 250, this.height * 0.415, [this.resumeButton, resumeImage]).setScale(0.75 * 0.75);

        this.soundButton = this.add.image(0, 0, 'UI_New', 'UI_New_3').setInteractive().setOrigin(0.5);
        this.soundImage = this.add.image(10, 0, 'UI_New', App.MUTE ? 'UI_New_5' : 'UI_New_6').setOrigin(0.5).setScale(1.25);
        this.soundContainer = this.add.container(this.width_half, this.height * 0.415, [this.soundButton, this.soundImage]).setScale(0.75 * 0.75);

        this.closeButton = this.add.image(0, 0, 'UI_New', 'UI_New_3').setInteractive().setOrigin(0.5);
        var closeImage = this.add.image(0, 0, 'closeButton').setOrigin(0.5);
        var closeContainer = this.add.container(this.width_half + 250, this.height * 0.415, [this.closeButton, closeImage]).setScale(0.75 * 0.75);

        this.pauseMenuContainer = this.add.container(0, 0, [this.pauseMenu, this.soundContainer, resumeContainer, closeContainer, this.pauseHeader]);
        this.pauseMenuContainer.setVisible(false).setScrollFactor(1, 0);
    }

    private exitConfirmationMenu: Phaser.GameObjects.Image;
    private exitYesButton: Phaser.GameObjects.Text;
    private exitNoButton: Phaser.GameObjects.Text;
    private exitAdContainer: Phaser.GameObjects.Container;

    setExitConfirmation() {
        this.exitConfirmationMenu = this.add.image(0, 0, 'ScoreBoard', 'ScoreBoard_0').setOrigin(0.5).setScale(0.75 * 1.3).setRotation(3.14);
        var exitConfirmationText = this.add.text(0, -this.adMenu.displayHeight / 4, 'Are you sure you want to exit?', {
            fontFamily: 'FredokaOne', fontSize: '81px', fontStyle: 'bold', fill: '#712E3A'
        }).setOrigin(0.5);

        this.exitYesButton = this.add.text(this.exitConfirmationMenu.displayWidth / 4, this.exitConfirmationMenu.displayHeight * 0.35, 'YES', { fontFamily: 'FredokaOne', fontSize: '120px', fontStyle: 'bold', fill: '#00FF00' });
        this.exitYesButton.setInteractive().setOrigin(0.5);
        this.exitNoButton = this.add.text(-this.exitConfirmationMenu.displayWidth / 4, this.exitConfirmationMenu.displayHeight * 0.35, 'NO', { fontFamily: 'FredokaOne', fontSize: '120px', fontStyle: 'bold', fill: '#FF0000' });
        this.exitNoButton.setInteractive().setOrigin(0.5);

        this.exitAdContainer = this.add.container(this.width_half, this.height * 0.4, [this.exitConfirmationMenu, this.exitYesButton, this.exitNoButton, exitConfirmationText]);
        this.exitAdContainer.setVisible(false);
    }

    setAdMenu() {
        this.adMenu = this.add.image(0, 0, 'ScoreBoard', 'ScoreBoard_0').setOrigin(0.5).setScale(0.75 * 1.3).setRotation(3.14);
        var adText = this.add.text(0, -this.adMenu.displayHeight / 3, Localisation.TEXTS.GAME_PLAY_AN_AD_TO_CONTINUE_TEXT[App.langIndex], {
            fontFamily: 'FredokaOne', fontSize: '72px', fontStyle: 'bold', fill: '#712E3A', wordWrap: { width: 1000, useAdvancedWrap: true }, align: 'center'
        }).setOrigin(0.5);

        this.countDownTween = this.tweens.addCounter({
            from: 0,
            to: App.AD_TIME,
            duration: App.AD_TIME * 1000,
            onComplete: () => {
            if (!this.scene.isActive() || !this.adContainer.scene) return;
            this.adContainer.setVisible(false);
            this.showRetryMenu();
            },
            onCompleteScope: this,
            onUpdate: (tween) => {
                if (!this.scene.isActive() || !this.adCountDown.scene) return;
                var value = App.AD_TIME - Phaser.Math.FloorTo(tween.getValue(), 0, 10);
                this.adCountDown.setText(value.toString());
            },
            onUpdateScope: this,
            paused: true
        });

        this.adCountDown = this.add.text(0, 0.75 * -20, App.AD_TIME.toString(), { fontFamily: 'FredokaOne', fontSize: '150px', fontStyle: 'bold', fill: '#FFFFFF' });
        this.adCountDown.setOrigin(0.5);

        this.yesButton = this.add.text(this.adMenu.displayWidth / 4, this.adMenu.displayHeight * 0.2, Localisation.TEXTS.GAME_YES_TEXT[App.langIndex], { fontFamily: 'FredokaOne', fontSize: '120px', fontStyle: 'bold', fill: '#712E3A' });
        this.yesButton.setInteractive().setOrigin(0.5);
        this.noButton = this.add.text(-this.adMenu.displayWidth / 4, this.adMenu.displayHeight * 0.2, Localisation.TEXTS.GAME_NO_TEXT[App.langIndex], { fontFamily: 'FredokaOne', fontSize: '120px', fontStyle: 'bold', fill: '#712E3A' });
        this.noButton.setInteractive().setOrigin(0.5);

        this.adContainer = this.add.container(this.width_half, this.height * 0.4, [this.adMenu, this.yesButton, this.noButton, this.adCountDown, adText]);
        this.adContainer.setVisible(false);
    }

    setupAdWaitingContainer() {
        this.adWaitingMenu = this.add.image(0, 0, 'ScoreBoard', 'ScoreBoard_0').setOrigin(0.5).setScale(0.75 * 1.3).setRotation(3.14);
        var adText = this.add.text(0, -this.adMenu.displayHeight / 50, 'Loading...', {
            fontFamily: 'FredokaOne', fontSize: '81px', fontStyle: 'bold', fill: '#712E3A'
        }).setOrigin(0.5);

        this.adWaitingContainer = this.add.container(this.width_half, this.height * 0.4, [this.adWaitingMenu, adText]);
        this.adWaitingContainer.setVisible(false);
    }

    restartGame() {
        if (!this.scene.isSleeping('NormalMode')) {
            App.SDK.showStickyAds();
            App.SDK.onGameRestart(this.registry.get('highScore'));
            this.sound.play('Click');
            this.gameScene.cameras.main.setAlpha(1);
            this.retryContainer.setVisible(false);
            this.pauseMenuContainer.setVisible(false);
            this.pauseContainer.setVisible(true);
            this.rubixContainer.setVisible(true);
            this.lifeContainer.setVisible(true);
            this.starsContainer.setVisible(true);
            this.inGame = true;
            this.paused = false;
            if (App.MUTE == false) {
                this.changeAudioState(false);
            }
            if (!App.BGM.isPlaying) {
                App.BGM.play({loop: true});
            }
            if (this.scene.isSleeping('Tutorial')) {
                this.scene.wake('Tutorial');
            }
            this.gameScene.restartGame();
            this.scoreText.setVisible(true);
            this.highScoreText.setVisible(true);
        }
    }

    goToMainMenu() {
        if (App.MUTE == false) {
            this.changeAudioState(false);
        }
        App.BGM.stop();
        App.lives = App.maxLives;
        App.characterIndex = 0;
        this.inGame = false;
        this.sound.play('Click');
        this.retryContainer.setVisible(false);
        this.pauseMenuContainer.setVisible(false);
        this.gameScene.restartGame();
        this.registry.destroy();
        this.paused = false;
        this.scene.stop('NormalMode');
        this.scene.stop('RushMode');
        this.scene.stop('UI');
        this.scene.stop('Tutorial');
        this.scene.start('MainMenu');
        this.unsubscribeEvents();
    }

    exitGame() { // Called by Exit button in Game Over panel.
        // if (App.FBInstant.activeTournament) {
        //     if (App.FBInstant.hasTournamentEnded == false) {
        //         App.SDK.isTournamentAfterGame = true;
        //     }
        //     else {
        //         App.SDK.isTournamentAfterGame = false;
        //     }
        // }
        // else {
        //     App.SDK.isTournamentAfterGame = false;
        // }
        App.SDK.isTournamentAfterGame = false; // Proxy Code. Remove Later.
        if (App.SDK.canShowInterstitialAd == true) {
            this.retryContainer.setVisible(false);
            this.adWaitingContainer.setVisible(true);
            this.sound.mute = true;
            App.SDK.watchInterstitialAd((value) => {
                this.adWaitingContainer.setVisible(false);
                if (!App.MUTE) {
                    this.sound.mute = false;
                }
                this.goToMainMenu();
                App.SDK.loadInterstitialAd();
            });
        }
        else {
            this.goToMainMenu();
        }
    }

    unsubscribeEvents() {
        this.gameScene.emitter.off('gameOverScreen', this.setGameOverScreen, this);

        this.registry.events.off('changedata', this.updateData, this);
        this.retryButton.off('pointerup', this.restartGame, this);
        this.exitButton.off('pointerup', this.exitGame, this);
        this.pauseButton.off('pointerup', this.pauseGame, this);
        this.resumeButton.off('pointerup', this.resumeGame, this);
        this.soundButton.off('pointerdown', this.setSound, this);
        this.closeButton.off('pointerdown', this.closeGame, this);
        this.yesButton.off('pointerdown', () => this.showAd(0), this);
        this.noButton.off('pointerdown', () => this.onRewardsAd(false), this);

        // this.fbInstantShareButton.off('pointerup', this.SDKShare, this);
    }

    updateData(parent, key, data) {
        if (key == 'score') {
            this.scoreText.setText(data);
        }
        else if (key == 'highScore') {
            App.SDK.HighestScore = data;
            this.highScoreText.setText(Localisation.TEXTS.GAME_BEST_TEXT[App.langIndex] + ': ' + data);
        }
        else if (key == 'rubixCubeScore') {
            if (data == 0) {
                this.rubixCubesUI1.setTexture('Ui_4', 'Ui_4_3').setScale(0.75 * 0.4);
                this.rubixCubesUI2.setTexture('Ui_4', 'Ui_4_3').setScale(0.75 * 0.4);
                this.rubixCubesUI3.setTexture('Ui_4', 'Ui_4_3').setScale(0.75 * 0.4);
            }
            if (data == 1) {
                this.rubixCubesUI1.setTexture('RubixCube', 'RubixCube_0').setScale(0.75 * 1.1);
            }
            if (data == 2) {
                this.rubixCubesUI2.setTexture('RubixCube', 'RubixCube_0').setScale(0.75 * 1.1);
            }
            if (data == 3) {
                this.rubixCubesUI3.setTexture('RubixCube', 'RubixCube_0').setScale(0.75 * 1.1);
            }
        }
        else if (key == 'powerup') {
            if (data == '') {
                this.powerUpIcon.setVisible(false);
                this.powerUpTimer.setVisible(false);
                this.powerUpText.setVisible(false);
            }
            else {
                this.powerUpTimer.setVisible(true);
                if (data == 'spring') {
                    this.powerUpIcon.setFrame('PowerUps_1').setVisible(true);
                    this.powerUpText.setText(Localisation.TEXTS.GAME_POWERUP_STRETCH_TEXT[App.langIndex]).setVisible(true);
                }
                else if (data == 'cheese') {
                    this.powerUpIcon.setFrame('PowerUps_5').setVisible(true);
                    this.powerUpText.setText(Localisation.TEXTS.GAME_POWERUP_SLOW_TEXT[App.langIndex]).setVisible(true);
                }
                else if (data == 'ice') {
                    this.powerUpIcon.setFrame('PowerUps_10').setVisible(true);
                    this.powerUpText.setText(Localisation.TEXTS.GAME_POWERUP_FREEZE_TEXT[App.langIndex]).setVisible(true);
                }
                this.powerUpTextTween.play();
            }
        }
        else if (key == 'stars') {
            this.starsUILabel.setText(App.stars.toString());
        }
    }

    private resize(gameSize?: any) {
        this.cameras.main.width = gameSize.width;
        this.cameras.main.height = gameSize.height;
    }

    private SDKShare() {
        this.sound.play('Click');
        App.SDK.shareAsPost(this.registry.get('score'));
    }
}